import { t } from 'i18next';
import { Component, ErrorInfo, ReactNode } from 'react';
import ErrorModal from '@/components/ErrorModal';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * @deprecated This should not be a class component
 */
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorModal
          open={this.state.hasError}
          title={t('error.common_error_something_went_wrong_text', { ns: 'common' })}
          description={t('error.common_error_please_try_again_text', { ns: 'common' })}
          buttonText={t('error.common_error_button_label_ok', { ns: 'common' })}
          onButtonClick={() => {
            this.setState({ hasError: false });
          }}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
